import React, { useState } from 'react';
import { TextArea } from 'components/TextField/TextArea';
import { STEPS } from 'models/exercises/IExercisePlan';
import { IStep, PageContents } from './StrategyExercisePlan';
import { StyledTextboxContainer } from './StrategyExercisePlan.styled';

interface IStepOneProps extends IStep {
  setProblem: React.Dispatch<React.SetStateAction<string>>;
}

export const StepOnePage: React.FC<IStepOneProps> = ({ content, setStep, setProblem, handleError }) => {
  const [text, setText] = useState<string>('');
  const placeHolder = `eg. I have injured my wrist and can’t play for a few weeks`;
  const maxCharacters = 128;
  const errorMessage = 'Define the challenge'

  const onChange = (newValue: string): void => {
    setText(newValue);
  }

  const onCtaClick = (): void => {
    if (text.length === 0) {
      handleError && handleError({ isError: true, errorMessage });
      return;
    }

    handleError && handleError({ isError: false, errorMessage: '' })
    setProblem(text);
    setStep(STEPS.STEP_TWO);
  }

  return (
    <React.Fragment>
      <PageContents content={content} onCtaClick={onCtaClick}>
        <StyledTextboxContainer>
          <TextArea onChange={onChange} placeholder={placeHolder} maxCharacters={maxCharacters}></TextArea>
        </StyledTextboxContainer>
      </PageContents>
    </React.Fragment>
  )
}